import { queryOptions } from "@tanstack/react-query";
import { apiClient, unwrap } from "./client";

// Query keys follow the contract routes (AGENTS.md, state). Organisation-scoped data starts with ["org", orgId],
// so switching organisation never shows another organisation's cached data.
export const meQuery = () =>
  queryOptions({
    queryKey: ["customers", "/v1/me"],
    queryFn: () => unwrap(apiClient("customers").GET("/v1/me")),
    staleTime: 5 * 60_000,
  });

export const opsMeQuery = () =>
  queryOptions({
    queryKey: ["ops", "/v1/ops/me"],
    queryFn: () => unwrap(apiClient("ops").GET("/v1/ops/me")),
    staleTime: 5 * 60_000,
  });
